import {BaseTerms} from "../../infrastructure/models/base-terms";

export class ScoresListWidgetTerms extends BaseTerms {
  ALL_SCORES_FOOTBALL = "Football";
  WEB_MY_SCORES_PAGE_EMPTY_STATE_TODAY = "No followed games today, nor any of your followed teams are playing";
  WEB_MY_SELECTIONS_EMPTY_STATE_ALL = "Select Games, Teams and Competitions to follow them on My Scores";
  WEB_MY_SCORES_NO_LIVE_MATCHES = "Currently No Live Games";
  WEB_ALL_SCORES_SHOW_ALL_BUTTON = "See all matches";
  ALL_SCORES_COMPETITION_NO_GAMES = "No games on this day";
}
